import React, { useState, useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { ScrollArea } from '../components/ui/scroll-area';
import { FileText, Shield, AlertTriangle, Scale } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const TermsPage = () => {
  const [terms, setTerms] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTerms();
  }, []);

  const fetchTerms = async () => {
    try {
      const response = await axios.get(`${API}/legal/terms`);
      setTerms(response.data.terms);
    } catch (error) {
      console.error('Error fetching terms:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      
      <div className="max-w-4xl mx-auto px-4 py-24">
        <div className="text-center mb-12">
          <h1 className="font-heading text-3xl sm:text-4xl font-bold mb-4">
            Conditions Générales d'Utilisation
          </h1>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            En utilisant Kacos, vous acceptez les conditions suivantes. 
            Veuillez les lire attentivement avant d'utiliser notre plateforme.
          </p>
        </div>

        <div className="grid md:grid-cols-4 gap-4 mb-8">
          <Card className="card-dashboard text-center">
            <CardContent className="pt-6">
              <FileText className="w-8 h-8 mx-auto mb-2 text-primary" />
              <p className="text-sm font-medium">CGU</p>
            </CardContent>
          </Card>
          <Card className="card-dashboard text-center">
            <CardContent className="pt-6">
              <Shield className="w-8 h-8 mx-auto mb-2 text-green-500" />
              <p className="text-sm font-medium">Protection</p>
            </CardContent>
          </Card>
          <Card className="card-dashboard text-center">
            <CardContent className="pt-6">
              <AlertTriangle className="w-8 h-8 mx-auto mb-2 text-yellow-500" />
              <p className="text-sm font-medium">Disclaimer</p>
            </CardContent>
          </Card>
          <Card className="card-dashboard text-center">
            <CardContent className="pt-6">
              <Scale className="w-8 h-8 mx-auto mb-2 text-secondary" />
              <p className="text-sm font-medium">Légal</p>
            </CardContent>
          </Card>
        </div>

        <Card className="card-dashboard">
          <CardHeader>
            <CardTitle>Conditions et Disclaimer</CardTitle>
          </CardHeader>
          <CardContent>
            {loading ? (
              <div className="flex justify-center py-8">
                <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-primary"></div>
              </div>
            ) : (
              <ScrollArea className="h-[600px] pr-4">
                <div className="prose prose-sm dark:prose-invert max-w-none">
                  <pre className="whitespace-pre-wrap font-body text-sm leading-relaxed">
                    {terms}
                  </pre>
                </div>
              </ScrollArea>
            )}
          </CardContent>
        </Card>
      </div>

      <Footer />
    </div>
  );
};

export default TermsPage;
